import { render, staticRenderFns } from "./ObjectiveBuilder.vue?vue&type=template&id=6d8a9f54&"
import script from "./ObjectiveBuilder.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ObjectiveBuilder.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports